import { Reason } from 'packages/rum';
import logError from 'app/error/logError';
import { FOUR_O_FOUR } from 'app/router/constants/paths';

const notFoundError = Error('Not found');

const logNotFoundError = context => {
  logError(notFoundError, {
    reason: Reason.Router,
    status: FOUR_O_FOUR,
    ...context,
  });
};

export { logNotFoundError };
